export default __webpack_public_path__ + "static/media/img-email-marketing-big.ff82a66e.png";